import { render, staticRenderFns } from "./base.component.vue?vue&type=template&id=12d2e732&"
import script from "./base.component.vue?vue&type=script&lang=js&"
export * from "./base.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports